import script from "./OnboardingAssistant.vue?vue&type=script&setup=true&lang=ts"
export * from "./OnboardingAssistant.vue?vue&type=script&setup=true&lang=ts"

import "./OnboardingAssistant.vue?vue&type=style&index=0&id=b4560df2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4560df2"]])

export default __exports__